import styled from 'styled-components';

export const SubSectionContainer = styled.div`
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 16px;
    margin-bottom: 16px;
    background: #ffffff;
`;
